var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DoCheck, ElementRef, EventEmitter, OnChanges, OnDestroy, SimpleChanges, } from '@angular/core';
import { CanUpdateErrorState, ErrorStateMatcher, MatAutocompleteSelectedEvent, MatFormFieldControl, MatInputBase, mixinErrorState, } from '@angular/material';
import { FormGroupDirective, NgControl, NgForm } from '@angular/forms';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Platform } from '@angular/cdk/platform';
import { Subject } from 'rxjs/Subject';
import { AgencyFieldService } from './agency-field.service';
import { FocusMonitor } from '@angular/cdk/a11y';
import * as _ from 'lodash';
export var _AgencyMixin = mixinErrorState(MatInputBase);
var AgencyFieldComponent = /** @class */ (function (_super) {
    __extends(AgencyFieldComponent, _super);
    //
    function AgencyFieldComponent(_elementRef, _platform, 
    /** @docs-private */
    ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, inputValueAccessor, fm, service) {
        var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
        _this._elementRef = _elementRef;
        _this._platform = _platform;
        _this.ngControl = ngControl;
        _this.fm = fm;
        _this.service = service;
        _this._disabled = false;
        _this._uid = _.uniqueId('agency-');
        _this.controlType = 'agency-';
        _this.focused = false;
        _this.stateChanges = new Subject();
        _this.placeholder = '';
        _this._readonly = false;
        _this._required = false;
        _this._onChange = _.noop;
        //
        _this.setAgencyPk = new EventEmitter();
        if (_this.ngControl) {
            // Note: we provide the value accessor through here, instead of
            // the `providers` to avoid running into a circular import.
            _this.ngControl.valueAccessor = _this;
        }
        _this.fm.monitor(_this._elementRef.nativeElement, true).subscribe(function (origin) {
            _this.focused = !!origin;
            _this.stateChanges.next();
        });
        _this.service.chosenAgency.subscribe(function (agency) {
            if (agency) {
                _this.setAgencyPk.emit(agency.pk);
            }
            else {
                _this.setAgencyPk.emit(null);
            }
        });
        return _this;
    }
    //
    AgencyFieldComponent.prototype.writeValue = function (value) {
        this._value = value;
    };
    Object.defineProperty(AgencyFieldComponent.prototype, "disabled", {
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        get: function () {
            if (this.ngControl && this.ngControl.disabled !== null) {
                return this.ngControl.disabled;
            }
            return this._disabled;
        },
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
            // Browsers may not fire the blur event if the input is disabled too quickly.
            // Reset from here to ensure that the element doesn't become stuck.
            if (this.focused) {
                this.focused = false;
                this.stateChanges.next();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyFieldComponent.prototype, "id", {
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value || this._uid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyFieldComponent.prototype, "required", {
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        get: function () {
            return this._required;
        },
        set: function (value) {
            this._required = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyFieldComponent.prototype, "value", {
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        get: function () {
            return this._value;
        },
        set: function (value) {
            if (value !== this._value) {
                this.writeValue(value);
                this.stateChanges.next();
                this._value = value;
                this._onChange(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyFieldComponent.prototype, "readonly", {
        /** Whether the element is readonly. */
        get: function () {
            return this._readonly;
        },
        set: function (value) {
            this._readonly = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyFieldComponent.prototype, "empty", {
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        get: function () {
            return !this._value || this._value.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyFieldComponent.prototype, "shouldLabelFloat", {
        get: function () {
            return this.focused || !this.empty;
        },
        enumerable: true,
        configurable: true
    });
    //
    AgencyFieldComponent.prototype.setDisabledState = function (isDisabled) {
        this._disabled = isDisabled;
    };
    AgencyFieldComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    AgencyFieldComponent.prototype.registerOnTouched = function (fn) {
    };
    AgencyFieldComponent.prototype.setDescribedByIds = function (ids) {
        this._ariaDescribedby = ids.join(' ');
    };
    AgencyFieldComponent.prototype.onContainerClick = function (event) {
    };
    AgencyFieldComponent.prototype.ngOnChanges = function (changes) {
        this.stateChanges.next();
    };
    AgencyFieldComponent.prototype.ngOnDestroy = function () {
        this.stateChanges.complete();
    };
    AgencyFieldComponent.prototype.ngDoCheck = function () {
        // Copied from angualr 2 matInput
        if (this.ngControl) {
            // noinspection TypeScriptUnresolvedFunction
            this.updateErrorState();
        }
    };
    //
    AgencyFieldComponent.prototype.updateSearch = function () {
        this.service.agencyString.next(this._value);
    };
    AgencyFieldComponent.prototype.selectedAgency = function (event) {
        var agencyPk = +event.option._getHostElement().dataset['agencyPk'];
        this.service.selectedAgencyPk.next(agencyPk);
    };
    return AgencyFieldComponent;
}(_AgencyMixin));
export { AgencyFieldComponent };
